module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__chileClassic_White.7ba2b8c5.svg";